module.exports = __webpack_public_path__ + "img/pin.8d8f1eff.svg";